"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var _fonts = require("../fonts");
var _Svg = require("../Svg");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var close = function close(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.99999 5.58599L11.95 0.635986L13.364 2.04999L8.41399 6.99999L13.364 11.95L11.95 13.364L6.99999 8.41399L2.04999 13.364L0.635986 11.95L5.58599 6.99999L0.635986 2.04999L2.04999 0.635986L6.99999 5.58599Z",
    fill: "currentColor"
  }));
};
close.defaultProps = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ModalHeader = (0, _styledComponents.default)(_reactstrap.ModalHeader)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: none;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n"])));
var Header = function Header(props) {
  return /*#__PURE__*/_react.default.createElement(ModalHeader, _extends({
    tag: _fonts.H4,
    close: /*#__PURE__*/_react.default.createElement(_Svg.Svg, {
      as: close,
      onClick: props.toggle,
      cursor: "pointer"
    })
  }, props));
};
exports.Header = Header;